// TeamIntegrationsCategoriesContainer.js
import React, { useState, useRef } from 'react';
import { Box } from '@mui/material';
import TeamIntegrationsCategoriesMenu from './TeamIntegrationsCategoriesMenu';
import TeamRecommendedContainer from './TeamRecommendedContainer';
import TeamLeadExportContainer from './TeamLeadExportContainer';
import TeamMemberImportContainer from './TeamMemberImportContainer';
import TeamEmailContainer from './TeamEmailContainer';
import TeamSAMLContainer from './TeamSAMLContainer';
import TeamCalendarContainer from './TeamCalendarContainer';

const TeamIntegrationsCategoriesContainer = ({ 
    searchTerm = '', 
    subteamId = null,
    availableIntegrations = [],
    connectedIntegrations = [],
    onIntegrationClick,
    onDisconnect,
    isIntegrationConnected,
    getConnectionStatus,
    loading = false
}) => {
    const [activeCategory, setActiveCategory] = useState('Recommended');
    const containerRef = useRef(null);
    const sectionRefs = {
        'Recommended': useRef(null),
        'Lead Export': useRef(null),
        'Team Member Import': useRef(null),
        'Email': useRef(null),
        'SAML': useRef(null),
        'Calendar Booking': useRef(null)
    };

    const handleCategoryChange = (categoryName) => {
        setActiveCategory(categoryName);

        if (sectionRefs[categoryName] && sectionRefs[categoryName].current) {
            const sectionElement = sectionRefs[categoryName].current;
            const containerElement = containerRef.current;

            if (containerElement && sectionElement) {
                const sectionTop = sectionElement.offsetTop;
                containerElement.scrollTop = sectionTop;
            }
        }
    };

    return (
        <Box
            sx={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                height: '100%',
                display: 'flex',
                pt: 3,
                px: 1,
                flexDirection: 'column',
                overflow: 'hidden'
            }}
        >
            <Box sx={{ flexShrink: 0 }}>
                <TeamIntegrationsCategoriesMenu
                    activeCategory={activeCategory}
                    onCategoryChange={handleCategoryChange}
                />
            </Box>

            <Box
                ref={containerRef}
                sx={{
                    flex: 1,
                    overflowY: 'auto',
                    px: 3,
                    pb: 3,
                    position: 'relative',
                    '&::-webkit-scrollbar': {
                        width: '8px'
                    },
                    '&::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                        borderRadius: '4px'
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: '#888',
                        borderRadius: '4px',
                        '&:hover': {
                            background: '#555'
                        }
                    }
                }}
            >
                <Box
                    ref={sectionRefs['Recommended']}
                    id="Recommended"
                    sx={{ position: 'relative', mb: 6 }}
                >
                    <TeamRecommendedContainer 
                        searchTerm={searchTerm} 
                        subteamId={subteamId}
                        availableIntegrations={availableIntegrations}
                        onIntegrationClick={onIntegrationClick}
                        isIntegrationConnected={isIntegrationConnected}
                        getConnectionStatus={getConnectionStatus}
                    />
                </Box>
                <Box
                    ref={sectionRefs['Lead Export']}
                    id="Lead Export"
                    sx={{ position: 'relative', mb: 6 }}
                >
                    <TeamLeadExportContainer 
                        searchTerm={searchTerm} 
                        subteamId={subteamId}
                        availableIntegrations={availableIntegrations}
                        onIntegrationClick={onIntegrationClick}
                        isIntegrationConnected={isIntegrationConnected}
                        getConnectionStatus={getConnectionStatus}
                    />
                </Box>
                <Box
                    ref={sectionRefs['Team Member Import']}
                    id="Team Member Import"
                    sx={{ position: 'relative', mb: 6 }}
                >
                    <TeamMemberImportContainer 
                        searchTerm={searchTerm} 
                        subteamId={subteamId}
                        availableIntegrations={availableIntegrations}
                        onIntegrationClick={onIntegrationClick}
                        isIntegrationConnected={isIntegrationConnected}
                        getConnectionStatus={getConnectionStatus}
                    />
                </Box>
                <Box
                    ref={sectionRefs['Email']}
                    id="Email"
                    sx={{ position: 'relative', mb: 6 }}
                >
                    <TeamEmailContainer 
                        searchTerm={searchTerm} 
                        subteamId={subteamId}
                        availableIntegrations={availableIntegrations}
                        onIntegrationClick={onIntegrationClick}
                        isIntegrationConnected={isIntegrationConnected}
                        getConnectionStatus={getConnectionStatus}
                    />
                </Box>
                <Box
                    ref={sectionRefs['SAML']}
                    id="SAML"
                    sx={{ position: 'relative', mb: 6 }}
                >
                    <TeamSAMLContainer 
                        searchTerm={searchTerm} 
                        subteamId={subteamId}
                        availableIntegrations={availableIntegrations}
                        onIntegrationClick={onIntegrationClick}
                        isIntegrationConnected={isIntegrationConnected}
                        getConnectionStatus={getConnectionStatus}
                    />
                </Box>
                <Box
                    ref={sectionRefs['Calendar Booking']}
                    id="Calendar Booking"
                    sx={{ position: 'relative', mb: 6 }}
                >
                    <TeamCalendarContainer 
                        searchTerm={searchTerm} 
                        subteamId={subteamId}
                        availableIntegrations={availableIntegrations}
                        onIntegrationClick={onIntegrationClick}
                        isIntegrationConnected={isIntegrationConnected}
                        getConnectionStatus={getConnectionStatus}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default TeamIntegrationsCategoriesContainer;

